function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useRef } from 'react';
import { useMultipleSelection, useCombobox } from 'downshift';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { RECENT } from './autocomplete-types';
import { MIN_QUERY_LENGTH } from './constants';
import useRecentSearches from './use-recent-searches';
var useAutocomplete = _ref => {
  var _ref$initialSelectedI = _ref.initialSelectedItems,
    initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
    _ref$suggestions = _ref.suggestions,
    suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions,
    _ref$types = _ref.types,
    types = _ref$types === void 0 ? [] : _ref$types,
    _ref$singleSelect = _ref.singleSelect,
    singleSelect = _ref$singleSelect === void 0 ? false : _ref$singleSelect,
    _ref$immediateTypes = _ref.immediateTypes,
    immediateTypes = _ref$immediateTypes === void 0 ? [] : _ref$immediateTypes,
    queryText = _ref.queryText,
    _ref$setQueryText = _ref.setQueryText,
    setQueryText = _ref$setQueryText === void 0 ? () => {} : _ref$setQueryText,
    recentSearchKey = _ref.recentSearchKey,
    _ref$saveRecentOnSear = _ref.saveRecentOnSearch,
    saveRecentOnSearch = _ref$saveRecentOnSear === void 0 ? false : _ref$saveRecentOnSear,
    _ref$onLoadedRecentSe = _ref.onLoadedRecentSearches,
    onLoadedRecentSearches = _ref$onLoadedRecentSe === void 0 ? () => {} : _ref$onLoadedRecentSe,
    _ref$onSearch = _ref.onSearch,
    onSearch = _ref$onSearch === void 0 ? () => {} : _ref$onSearch,
    onRecentSearch = _ref.onRecentSearch,
    onImmediateSearch = _ref.onImmediateSearch,
    _ref$onSelectionChang = _ref.onSelectionChange,
    onSelectionChange = _ref$onSelectionChang === void 0 ? () => {} : _ref$onSelectionChang;
  var savedSelectedItems = useRef(initialSelectedItems);
  var isImmediate = item => immediateTypes.includes(item === null || item === void 0 ? void 0 : item.type);
  var isRecent = item => (item === null || item === void 0 ? void 0 : item.type) === RECENT;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var initialRender = useRef(true);
  var handleSelectionChange = useRef(onSelectionChange);
  var _useRecentSearches = useRecentSearches({
      recentSearchKey,
      onLoadedRecentSearches
    }),
    originalRecentItems = _useRecentSearches.recentItems,
    saveRecentSearch = _useRecentSearches.saveRecentSearch;
  var _useMultipleSelection = useMultipleSelection({
      initialSelectedItems
    }),
    getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
    addSelectedItem = _useMultipleSelection.addSelectedItem,
    setSelectedItems = _useMultipleSelection.setSelectedItems,
    removeSelectedItem = _useMultipleSelection.removeSelectedItem,
    getDropdownProps = _useMultipleSelection.getDropdownProps,
    selectedItems = _useMultipleSelection.selectedItems;
  var filteredSuggestions = suggestions.filter(each => !selectedItems.some(selected => selected.type === each.type && selected.name === each.name));
  var recentItems = !selectedItems.length && !filteredSuggestions.length && queryText.length < MIN_QUERY_LENGTH ? originalRecentItems.filter(recentItem => recentItem.value.every(each => types.includes(each.type))) : [];
  var handleSearch = () => {
    if (saveRecentOnSearch && selectedItems.length > 0) {
      saveRecentSearch(selectedItems);
    }
    onSearch(selectedItems);
  };
  var handleRecentSearch = selectedItem => {
    var value = selectedItem.value;
    if (onRecentSearch) {
      onRecentSearch(value);
    } else if (isImmediate(value[0]) && onImmediateSearch) {
      onImmediateSearch(value[0]);
    } else {
      onSearch(value);
    }
  };
  var handleImmediateSearch = selectedItem => {
    if (saveRecentOnSearch) {
      saveRecentSearch([selectedItem]);
    }
    if (onImmediateSearch) {
      onImmediateSearch(selectedItem);
    } else {
      onSearch([selectedItem]);
    }
  };
  var _useCombobox = useCombobox({
      items: [...recentItems, ...filteredSuggestions].map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
        position: index + 1
      })),
      itemToString: () => '',
      onStateChange: _ref2 => {
        var inputValue = _ref2.inputValue,
          type = _ref2.type,
          selectedItem = _ref2.selectedItem;
        switch (type) {
          case useCombobox.stateChangeTypes.InputChange:
            setQueryText(inputValue);
            break;
          case useCombobox.stateChangeTypes.InputKeyDownEnter:
          case useCombobox.stateChangeTypes.ItemClick:
          case useCombobox.stateChangeTypes.InputBlur:
            if (selectedItem) {
              setQueryText('');
              selectItem(null);
              if (isRecent(selectedItem) || singleSelect) {
                closeMenu();
              }
              if (!isRecent(selectedItem)) {
                sendEvent('autocomplete-item-select', {
                  item: selectedItem
                });
              }
              if (isRecent(selectedItem)) {
                setSelectedItems(selectedItem.value);
              } else if (singleSelect || isImmediate(selectedItem) || isImmediate(selectedItems[0])) {
                setSelectedItems([selectedItem]);
              } else {
                addSelectedItem(selectedItem);
              }
              selectItem(null);
              if (isRecent(selectedItem)) {
                handleRecentSearch(selectedItem);
              } else if (isImmediate(selectedItem)) {
                handleImmediateSearch(selectedItem);
              }
            }
            break;
          default:
            break;
        }
      }
    }),
    isOpen = _useCombobox.isOpen,
    _getInputProps = _useCombobox.getInputProps,
    getItemProps = _useCombobox.getItemProps,
    selectItem = _useCombobox.selectItem,
    getComboboxProps = _useCombobox.getComboboxProps,
    getMenuProps = _useCombobox.getMenuProps,
    openMenu = _useCombobox.openMenu,
    closeMenu = _useCombobox.closeMenu,
    highlightedIndex = _useCombobox.highlightedIndex,
    setInputValue = _useCombobox.setInputValue;
  useEffect(() => {
    handleSelectionChange.current = onSelectionChange;
  }, [onSelectionChange]);
  useEffect(() => {
    if (!initialRender.current) {
      handleSelectionChange.current(selectedItems);
    }
  }, [selectedItems]);
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    }
  });
  var resetSelectedItems = () => {
    setSelectedItems(savedSelectedItems.current);
  };
  var onSearchButtonClick = () => {
    setQueryText('');
    handleSearch();
  };
  return {
    /** Whether or not the suggestion menu is open */
    isOpen,
    /** The list of suggestions after filtering for already selected items */
    filteredSuggestions,
    /** Whether or not there are any suggestions */
    hasData: (filteredSuggestions === null || filteredSuggestions === void 0 ? void 0 : filteredSuggestions.length) > 0,
    /** The current selected items */
    selectedItems,
    /** Removes an item from the selected list */
    removeSelectedItem,
    /** Resets the selected items to what they were when the autocomplete first mounted */
    resetSelectedItems,
    /** Opens the suggestion menu */
    openMenu,
    closeMenu,
    setInputValue,
    onSearchButtonClick,
    getComboboxProps,
    getSelectedItemProps,
    getInputProps: function getInputProps() {
      return _getInputProps(getDropdownProps(...arguments));
    },
    getMenuProps,
    getItemProps,
    recentItems,
    highlightedIndex
  };
};
export default useAutocomplete;